import { render } from "./DiscountSettings.vue?vue&type=template&id=2b16e7cd&scoped=true"
import script from "./DiscountSettings.vue?vue&type=script&lang=js"
export * from "./DiscountSettings.vue?vue&type=script&lang=js"

import "./DiscountSettings.vue?vue&type=style&index=0&id=2b16e7cd&scoped=true&lang=css"
import "./DiscountSettings.vue?vue&type=style&index=1&id=2b16e7cd&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b16e7cd"]])

export default __exports__